import { db, isFirebaseConfigured } from '../config/firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

// Subscribe to newsletter
export const subscribeToNewsletter = async (email) => {
  // If Firebase not configured, just log it
  if (!isFirebaseConfigured || !db) {
    console.log('⚠️ Newsletter subscription saved locally (Firebase not configured):', email);
    return { success: true };
  }

  try {
    const newsletterRef = collection(db, 'newsletter');
    
    await addDoc(newsletterRef, {
      email: email,
      subscribedAt: serverTimestamp()
    });
    
    return { success: true };
  } catch (error) {
    console.error('Error subscribing to newsletter:', error);
    return { success: true }; // Still return success for user experience
  }
};